import React from 'react'
import { Link } from 'react-router-dom'

import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const MAIN_MENU_BUTTON_WRAPPER_STYLES =
  'flex flex-col box-border w-5/12 p-1 m-0'
const ICON_WRAPPER_STYLES = 'flex flex-col m-auto content-center justify-center'

const CONTAINER_STYLES =
  'flex flex-col justify-center items-center w-full p-4 relative bg-primary rounded text-contentareabackground font-body hover:bg-navbackground hover:text-contentareabackground'

const LINK_STYLES = 'absolute top-0 left-0 h-full w-full opacity-0'

const LABEL_STYLES = 'flex text-contentareabackground my-2 mx-auto text-center'

export interface IMainMenuButtonProps {
  to: string
  icon: IconDefinition
  label: string
}

export const MainMenuButton: React.FC<IMainMenuButtonProps> = ({
  to,
  icon,
  label,
}) => (
  <div className={MAIN_MENU_BUTTON_WRAPPER_STYLES}>
    <div className={CONTAINER_STYLES}>
      <div className={ICON_WRAPPER_STYLES}>
        <FontAwesomeIcon icon={icon} size="4x" className="mx-auto" />
        <span className={LABEL_STYLES}>{label}</span>
      </div>
      <Link className={LINK_STYLES} to={to}>
        {label}
      </Link>
    </div>
  </div>
)
